module.exports = "/_next/static/images/SanofiVideoCoverImage-f30bc89c694d0f0c7f3bdc75dece8cda.png";